import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=12b7a1c6&scoped=true"
import script from "./BasicProfile.vue?vue&type=script&lang=js"
export * from "./BasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BasicProfile.vue?vue&type=style&index=0&id=12b7a1c6&prod&scoped=true&lang=css"
import style1 from "./BasicProfile.vue?vue&type=style&index=1&id=12b7a1c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7a1c6",
  null
  
)

export default component.exports